import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import Action from '../DebtPaymentComponents/action';
import {CalendarIcon} from '../DebtPaymentComponents/calendarIcon';
import {errorEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {CSSTransition} from 'react-transition-group';
import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';
import {report, getReportParams} from '../../../../middleware/report';

const BillingCycleError = (props) => {
  const {saveAs} = require('file-saver');
  const ics = require('ics');
  const [mount, setMount] = useState(false);
  const [errorMsg, setErrorMsg] = useState(props.error.message);

  let mainImg = require('../images/icons-error.svg');
  let calendar = <CalendarIcon />;

  const event = {
    start: props.error.addToCalendar,
    duration: {days: 1},
    title: `תשלום חוב - ${window.Config.brand_Name_HE}`,
    description: 'קישור תשלום חוב',
    location: '',
    status: 'CONFIRMED',
    busyStatus: 'BUSY',
  };

  const actionOnClick = (event) => {
    if (props.isPrivate) {
      gaEvent(
        gaParams.PRIVATEDEBT_ADDTOCALENDAR_CLICK.category,
        gaParams.PRIVATEDEBT_ADDTOCALENDAR_CLICK.eventType,
        `יתרת תשלום מועברת לחיוב`,
      );
    } else {
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_BILLERROR.category,
        gaParams.DEBT_PAYMENT_CLICK_BILLERROR.eventType,
        gaParams.DEBT_PAYMENT_CLICK_BILLERROR.eventParams,
      );
    }

    ics.createEvent(event, (error, value) => {
      if (error) {
        return;
      }
      var file = new File([value], 'CellcomReminder.ics', {type: 'text/calendar'});
      saveAs(file);
    });
  };

  const title = props.isMobile ? 'מצטערים, אין אפשרות \nכרגע לשלם את החוב' : 'מצטערים, אין אפשרות \nכרגע לשלם את החוב';

  useEffect(() => {
    if (props.currentStep === errorEnum.BILLINGCYCLE) {
      setMount(true);
      setErrorMsg(props.error.message);
      if (props.isPrivate) {
        gaEvent(
          gaParams.PRIVATEDEBT_SPECIALERROR_SHOW.category,
          gaParams.PRIVATEDEBT_SPECIALERROR_SHOW.eventType,
          `יתרת תשלום מועברת לחיוב`,
        );
      } else {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_BILLERROR.category,
          gaParams.DEBT_PAYMENT_SHOW_BILLERROR.eventType,
          gaParams.DEBT_PAYMENT_SHOW_BILLERROR.eventParams,
        );
      }
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return (
    <CSSTransition key={11} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={title} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'כדי למנוע טעויות, אפשר להסדיר את \nהתשלום רק החל מ-' + errorMsg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center'>
          <Col md='auto'>
            <Action
              text={'להוספת תזכורת ליומן'}
              isPrivate={props.isPrivate}
              img={calendar}
              onclick={actionOnClick}
              fnParams={event}
              bold
              color={props.isPrivate ? 'privateText' : ' '}
            />
          </Col>
        </Row>
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness={!props.isPrivate} formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default BillingCycleError;
